import { Component, EventEmitter, OnDestroy, OnInit, Output, inject, signal } from "@angular/core"
import { FormControl, FormGroup, Validators } from "@angular/forms"
import { PATTERNS } from "src/app/meta/patterns.const"
import { PORTING_PROVIDER_OPTIONS } from "src/app/meta/porting-provider-options.const"
import { BusinessPortingService } from '../../services/business-porting.service';

@Component({
  selector: "ow-business-porting-form",
  templateUrl: "./business-porting-form.component.html"
})
export class BusinessPortingFormComponent implements OnInit, OnDestroy {

  @Output() updateValidity = new EventEmitter<boolean>(false)
  
  private readonly businessPortingService = inject(BusinessPortingService)

  public readonly PROVIDER_OPTIONS = PORTING_PROVIDER_OPTIONS

  public readonly form = new FormGroup({
    porting: new FormControl<boolean>(this.businessPortingService.getBusinessPorting().porting),
    numbersCount: new FormControl<number>(this.businessPortingService.getBusinessPorting().numbersCount),
    number1: new FormControl<string>(this.businessPortingService.getNumber(1)),
    number2: new FormControl<string>(this.businessPortingService.getNumber(2)),
    number3: new FormControl<string>(this.businessPortingService.getNumber(3)),
    number4: new FormControl<string>(this.businessPortingService.getNumber(4)),
    number5: new FormControl<string>(this.businessPortingService.getNumber(5)),
    number6: new FormControl<string>(this.businessPortingService.getNumber(6)),
    number7: new FormControl<string>(this.businessPortingService.getNumber(7)),
    number8: new FormControl<string>(this.businessPortingService.getNumber(8)),
    number9: new FormControl<string>(this.businessPortingService.getNumber(9)),
    number10: new FormControl<string>(this.businessPortingService.getNumber(10)),
    provider: new FormControl<string>(this.businessPortingService.getBusinessPorting().provider),
  })

  public readonly showFields = signal<boolean>(false)
  public readonly numbersCount = signal<number>(1)

  private readonly subscriptions = [
    this.form.controls.porting.valueChanges.subscribe((value) => {
      this.onPortingChange()
      if (this.form.controls.porting.valid) {
        this.businessPortingService.setBusinessPorting({ porting: value! })
      }
    }),
    this.form.controls.numbersCount.valueChanges.subscribe((value) => {
      this.onNumbersCountChange()
      if (this.form.controls.numbersCount.valid) {
        this.businessPortingService.setBusinessPorting({ numbersCount: value! })
      }
    }),
    this.form.controls.number1.valueChanges.subscribe((value) => {
      if (this.form.controls.number1.valid) {
        this.businessPortingService.setNumber(1, value!)
      }
    }),
    this.form.controls.number2.valueChanges.subscribe((value) => {
      if (this.form.controls.number2.valid) {
        this.businessPortingService.setNumber(2, value!)
      }
    }),
    this.form.controls.number3.valueChanges.subscribe((value) => {
      if (this.form.controls.number3.valid) {
        this.businessPortingService.setNumber(3, value!)
      }
    }),
    this.form.controls.number4.valueChanges.subscribe((value) => {
      if (this.form.controls.number4.valid) {
        this.businessPortingService.setNumber(4, value!)
      }
    }),
    this.form.controls.number5.valueChanges.subscribe((value) => {
      if (this.form.controls.number5.valid) {
        this.businessPortingService.setNumber(5, value!)
      }
    }),
    this.form.controls.number6.valueChanges.subscribe((value) => {
      if (this.form.controls.number6.valid) {
        this.businessPortingService.setNumber(6, value!)
      }
    }),
    this.form.controls.number7.valueChanges.subscribe((value) => {
      if (this.form.controls.number7.valid) {
        this.businessPortingService.setNumber(7, value!)
      }
    }),
    this.form.controls.number8.valueChanges.subscribe((value) => {
      if (this.form.controls.number8.valid) {
        this.businessPortingService.setNumber(8, value!)
      }
    }),
    this.form.controls.number9.valueChanges.subscribe((value) => {
      if (this.form.controls.number9.valid) {
        this.businessPortingService.setNumber(9, value!)
      }
    }),
    this.form.controls.number10.valueChanges.subscribe((value) => {
      if (this.form.controls.number10.valid) {
        this.businessPortingService.setNumber(10, value!)
      }
    }),
    this.form.controls.provider.valueChanges.subscribe((value) => {
      if (this.form.controls.provider.valid) {
        this.businessPortingService.setBusinessPorting({ provider: value! })
      }
    }),
    this.form.statusChanges.subscribe(() => {
      this.updateValidity.emit(this.form.valid)
    })
  ]

  ngOnInit(): void {
    this.onPortingChange()
    this.onNumbersCountChange()
    this.updateValidity.emit(this.form.valid)
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe()
    })
  }

  private onPortingChange(): void {
    this.showFields.set(this.form.controls.porting.value!)
    this.updateNumbersValidators()
    if (this.showFields()) {
      this.form.controls.provider.addValidators(Validators.required)
    } else {
      this.form.controls.provider.clearValidators()
    }
    this.form.controls.provider.updateValueAndValidity()
  }

  private onNumbersCountChange(): void {
    this.numbersCount.set(this.form.controls.numbersCount.value!)
    this.updateNumbersValidators()
  }

  private updateNumbersValidators(): void {
    let i = 1
    while (i <= 10) {
      const control = this.form.get(`number${i}`)
      if (this.form.controls.porting.value && i <= this.numbersCount()) {
        control?.addValidators([Validators.required, Validators.pattern(PATTERNS.NUMERIC)])
      } else {
        control?.clearValidators()
      }
      control?.updateValueAndValidity()
      i++
    }
  }

  public addNumber() {
    this.form.controls.numbersCount.setValue(this.form.controls.numbersCount.value! + 1)
  }

  public remNumber() {
    this.form.controls.numbersCount.setValue(this.form.controls.numbersCount.value! - 1)
  }

}
